export default "__VITE_ASSET__Cp4vq82l__";